export enum EUserType {
  NaturalPerson = "naturalperson",
  LegalPerson = "legalperson",
}
